export default {"src":"/_next/static/media/Expired.568c7326.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};